export const ACTIVITY_QUEUE_CSV_HEADERS = [
  'DALID',
  'GPS UOID',
  'GPS Asset Status',
  'GPS Contract Status',
  'File Name',
  'Source Asset ID',
  'Provider BU',
  'Asset source',
  'Rights Category',
  'Title',
  'BU Rights',
  'Adaptation Rights',
  'Licensing Limitations',
  'DAL Asset status',
  'Usage Restrictions',
  'Image Type',
  'Marketing Use',
  'Credit Text',
  'Author Creator',
  'Copyright Holder',
  'Model Release',
  'Location Release',
  'Displayed Credit Text Required',
  'Finalized Flag',
  'Metadata Status',
  'GPS Contract ID',
  'Date Imported',
  'Imported By',
  'Notes',
];

export const ACTIVITY_QUEUE_CSV_FIELDS = [
  { type: 'asset', key: 'dal_id' },
  { type: 'asset', key: 'gps_id' },
  { type: 'metadata', key: 'gps-asset-status' },
  { type: 'metadata', key: 'gps-contract-status' },
  { type: 'asset', key: 'filename' },
  { type: 'metadata', key: 'alternate-ids' },
  { type: 'metadata', key: 'provider-bu' },
  { type: 'metadata', key: 'asset-source' },
  { type: 'metadata', key: 'rights-category' },
  { type: 'asset', key: 'title' },
  { type: 'metadata', key: 'business-unit-rights' },
  { type: 'metadata', key: 'adaptation-rights' },
  { type: 'metadata', key: 'licensing-limitations' },
  { type: 'metadata', key: 'dal-asset-status' },
  { type: 'metadata', key: 'usage-restriction' },
  { type: 'metadata', key: 'image-type' },
  { type: 'metadata', key: 'marketing-use' },
  { type: 'metadata', key: 'credit' },
  { type: 'metadata', key: 'asset-creator' },
  { type: 'metadata', key: 'copyright-holder' },
  { type: 'metadata', key: 'model-release' },
  { type: 'metadata', key: 'location-release' },
  { type: 'metadata', key: 'displayed-credit-required' },
  { type: 'metadata', key: 'finalized' },
  { type: 'metadata', key: 'metadata-status' },
  { type: 'metadata', key: 'gps-contract-id' },
  { type: 'asset', key: 'created_at' },
  { type: 'asset', key: 'created_by' },
  { type: 'metadata', key: 'notes' },
];
